import Login from '../components/login/Login';

export default [
  {
    name: 'Login',
    path: '/login',
    component: Login,
  },
]
